export const GOOGLE_MAPS_API_KEY = 'AIzaSyDUnmEGqix9gziZQjtCQFJ7mCTSDV9yPDk';
export const AMPLITUDE_API_KEY = 'eade10d6f4746cbe34333e42ff653fbc';
